import React from "react";
import Header from "./components/Header";
import Content from "./components/Home-content";
import Footer from "./components/Footer";
function Home() {
  return (
    <div>
      <Header />
      <Content />
      <Footer />
    </div>
  );
}
export default Home;
